import React, { useEffect, useState } from 'react'
import VIPModal from './promos/hotels-promo-collection/vip-promo/VIPModal'
import HotelFormState from '../stores/HotelFormsState'
import HotelSearchActions from '../actions/HotelSearchActions'

export default function HotelVIPFeature () {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    const onChange = () => setShowModal(() => HotelFormState.isVisible('vip-hotels'))
    HotelFormState.addChangeListener(onChange)
    return () => HotelFormState.removeChangeListener(onChange)
  }, [])

  const handleModalClose = event => {
    if (event && event.preventDefault) event.preventDefault()
    HotelSearchActions.toggleVIPForm(false)
  }

  return showModal && <VIPModal show={showModal} onClose={handleModalClose} />
}
